import { requestData } from '../../config/services/datasets';
import { SERVER } from '../../config/server.config';
import * as TYPES from '../types';

export const setCustomTable = (results, user) => {
    return {
      type: TYPES.GET_CUSTOM_TABLE,
      customTable: results,
      user
    };
  };

export const setCustomTableLive = (results, user) => {
    return {
      type: TYPES.GET_CUSTOM_TABLE_LIVE,
      customTableLive: results,
      user
    };
  };

export const loadCustomTable = (user, live) =>{
    return async (dispatch) => {
    const results = await requestData(SERVER.GET_CUSTOM_TABLE(user, live));
    let defaultCustom;
    if(results === null ||(results && results.length === 0) ||(results[0] && !results[0].customfieldview || results[0].customfieldview.length === 0)){
      defaultCustom =[];
      if(live){
        dispatch(setCustomTableLive(defaultCustom, user));
      }else{
        dispatch(setCustomTable(defaultCustom, user));
      }
    }else{
      if(live){
        dispatch(setCustomTableLive(results[0].customfieldview, user));
      }else{
        dispatch(setCustomTable(results[0].customfieldview, user));
      }
    }
  };   
};

export const updateCustomTable = (customTableRows, user, live) =>{
  return async (dispatch) =>{
    const customEvents = customTableRows;
    const jsonBody = JSON.stringify(customEvents);
    fetch(SERVER.SET_CUSTOM_TABLE(user, live), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: jsonBody
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .finally(() => {
        dispatch(loadCustomTable(user, live? live: undefined));
      });
  };

};